import { useFormikContext } from 'formik';
import React, { ReactElement, useEffect, useState } from 'react';
import { Contact, Entente } from '../../../../../common/src/entities';
import { Button, Col, Row } from 'react-bootstrap';
import { insertStringAtNthComma, rolesStringParser, findContacts } from '../Utils/RoleModificator';
import { BiX } from 'react-icons/bi';
import { LABEL_COL } from '../constantes';
import { Popout } from '../Utils/Popout';
import { ValueType } from 'react-select';

export interface PropsChampMultipleActiviteProduit {
    numeroRole: number;
    nomRole: string;
    disabled?: boolean;
}

export default function ChampMultipleRoles(props: PropsChampMultipleActiviteProduit): ReactElement {
    const { values, setFieldValue } = useFormikContext<Entente>();
    const [selectedContacts, setselectedContacts] = useState<{ name: string; id: string }[]>([]);
    const [contactDisplay, setContactDisplay] = useState<{ label: string; name: string; id: number }[]>([]);

    const handleChange = (
        value: ValueType<
            {
                label: string;
                name: string;
                id: number;
            },
            false
        >,
    ) => {
        if (value) {
            const selectedContact = values.contacts.find((contact) => contact.contact.name === value.name);
            if (
                selectedContact &&
                !selectedContacts.some((contact) => contact.id === String(selectedContact.contact.id))
            ) {
                setselectedContacts([
                    ...selectedContacts,
                    { name: selectedContact.contact.name, id: String(selectedContact.contact.id) },
                ]);
            }
        }
    };

    const updateRolesField = (contacts: { name: string; id: string }[]) => {
        const roleString = values.roles || ';;;;';
        const idsString = contacts.map((contact) => contact.id).join(',');
        const output = insertStringAtNthComma(roleString, idsString, props.numeroRole, true);
        setFieldValue('roles', output);
    };
    
    const handleRemove = (idToRemove: string) => {
        const updatedContacts = selectedContacts.filter((contact) => contact.id !== idToRemove);
        updateRolesField(updatedContacts);
    };

    useEffect(() => {
        //On sépare la colonne roles de client en array de array:
        const roleIds = rolesStringParser(values.roles);
        // transforme les id dans le string a des object contact {name:string, id:string}
        //qui seront place dans selectedContacts
        if (roleIds[props.numeroRole - 1]) {
            const currentRoleIds = roleIds[props.numeroRole - 1];
            const newContacts = findContacts(currentRoleIds, values.contacts);
            setselectedContacts(newContacts);
        }
    }, []);

    useEffect(() => {
        if (selectedContacts.length === 0) return;
        updateRolesField(selectedContacts);
    }, [selectedContacts]);

    useEffect(() => {
        if (values.contacts) {
            const remainingContacts = values.contacts.filter(
                (contact) => !selectedContacts.some((selected) => selected.id === String(contact.contact.id)),
            );
            setContactDisplay(
                remainingContacts.map((contact) => ({
                    label: contact.contact.name,
                    name: contact.contact.name,
                    id: contact.contact.id,
                })),
            );
        }
    }, [values.contacts, selectedContacts]);

    const boxStyle = {
        display: 'flex',
        alignItems: 'center',
        border: '1px solid #ccc',
        margin: 0,
        borderRadius: '0.25rem',
        padding: '0 6px',
        fontSize: '14px',
    };

    return (
        <Row>
            <Col xs={LABEL_COL}>
                {props.numeroRole}
                {'.  '}
                {props.nomRole}
            </Col>
            <Col>
                <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '10px' }}>
                    {selectedContacts.length > 0 ? (
                        selectedContacts.map((contact, index) => (
                            <div key={index} className="selected-name" style={boxStyle}>
                                {contact.name}{' '}
                                {!props.disabled && (
                                    <Button
                                        variant="link"
                                        style={{ paddingTop: 0, paddingBottom: 0 }}
                                        className="d-none d-sm-flex align-items-center text-muted px-0"
                                        onClick={() => handleRemove(contact.id)}
                                    >
                                        <BiX size="1.25em" />
                                    </Button>
                                )}
                            </div>
                        ))
                    ) : (
                        <i style={boxStyle}>Aucun contact</i>
                    )}
                    <div className="p-0">
                        {!props.disabled && (
                            <Popout
                                id={`btnContact${props.numeroRole - 1}`}
                                titre="Ajouter un contact pour ce rôle"
                                entite={Contact}
                                size="sm"
                                options={contactDisplay}
                                getOptionLabel={(option) => option.name}
                                getOptionValue={(option) => option.id.toString()}
                                onChange={handleChange}
                                avecUnBouton
                            />
                        )}
                    </div>
                </div>
            </Col>
        </Row>
    );
}
